import _get from 'lodash/get'
import _isUndefined from 'lodash/isUndefined'
import queryString from 'query-string'

/*
  Multiline Ellipsis Simple Library
  Need to set container height and overflow:hidden
  example:
  export const ThumbnailTitle = styled('div')`{
    font-size: 2rem;
    ...
    height: 48px;
    overflow: hidden;
    ...
  }`;

  How to Call:
  import { setMultilineEllipsis } from '@source/lib/ellipsis';
  //on componentdidmount
  componentDidMount () {
    setMultilineEllipsis('multilineEllipsis');
  }

  //on render, can multiple component using the same classname
  <ThumbnailTitle className={'multilineEllipsis'}>{`"Grannies Try Weed For The First Time" GROUP CHAT "`}</ThumbnailTitle>
  <MovieTitle className={'multilineEllipsis'}>{`This is example of long long text`}</ThumbnailTitle>
 */

/**
 * @className = parameter untuk menentukan class div pada elemen yang disortir berdasarkan class. ex(text very long)
 *
 * @setMultilineEllipsis = className, komponen stateless untuk mendeklarasikan perubahan dinamis pada komponen tersebut
 *
 * fuction ini digunakan untuk mengatur set ellipsis sesuai dengan height dari parent classnya,
 *
 * Jika text melebihi dari height parrent class maka function mengembalikan text yg sudah di kurangi oleh array (return this very long...)
 *
 * jika tidak maka akan menampilkan text sesuai dengan height dari parent class
 */

export const setMultilineEllipsis = className => {
  const dataArray = document.getElementsByClassName(className)
    ;[].forEach.call(dataArray, function (el) {
      let wordArray = el.innerHTML.split(' ')
      while (el.scrollHeight > el.offsetHeight) {
        if (wordArray.length > 1) {
          wordArray.pop()
        } else {
          return
        }
        el.innerHTML = `${wordArray.join(' ')}...`
      }
    })
}

/**
 * @className = parameter untuk menentukan class div pada elemen yang disortir berdasarkan class
 *
 * @text = data yang dipanggil
 *
 * @unsetMultilineEllipsis = (className,text), komponen stateless untuk mendeklarasikan penggantian parameter text berdasakan class name yang di dapat
 *
 * Function ini digunakan untuk mengganti nilai value dengan parameter text berdasarkan className
 *
 * Ex : value sebelumnya = "this text..."
 *
 * Param text "this text new"
 *
 * Value selanjutnya = "this text new"
 */

export const unsetMultilineEllipsis = (className, text) => {
  const dataArray = document.getElementsByClassName(className)
    ;[].forEach.call(dataArray, function (el) {
      el.innerHTML = text
    })
}

/**
 * @contentType = parameter saat pertama function dipanggil (tipe konten),
 *
 * @isMovie = contentType, komponen stateless untuk mendeklarasikan movie
 *
 * function ini akan memvalidasi apakah contenType sudah sama dengan value
 *
 * jika content type sama dengan 1 atau sama dengan 7 atau sama dengan 8 maka akan mengembalikan nilai true .
 *
 * jika bukan maka akan mengembalikan nilai false
 */

export const isMovie = contentType => {
  if (contentType == 1 || contentType == 7 || contentType == 8) {
    return true
  }

  return false
}

/**
 * @contentTypeId = parameter parameter saat pertama function dipanggil (id tipe konten)
 *
 * @getContentTypeName = contentTypeId, komponen stateless untuk mengembalikan nama konten berdasarkan id,
 *
 * jika tidak ada id yg sama dengan case maka akan mengembalikan value "Undefined".
 */

export const getContentTypeName = contentTypeId => {
  switch (contentTypeId) {
    case 1:
      return 'vod'
    case 2:
      return 'linear'
    case 3:
      return 'live'
    case 4:
      return 'replay'
    case 5:
      return 'mixed'
    case 7:
      return 'movie'
    case 8:
      return 'trailers'
    case 9:
      return 'mola-featured'
    case 10:
      return 'mola-categories' /* always playlists */
    case 91:
      return 'original-content'
    case 93:
      return 'mola-sports'
    case 96:
      return 'mola-library'
    case 97:
      return 'banner'
    case 98:
      return 'single-video'
    case 'articles':
      return 'articles'
    case 'banner':
      return 'banner'
    default:
      return undefined
  }
}

/**
 * @videoType = ambil dari api video attributes.videoType e.g. https://stag.mola.tv/api/v2/videos/kuisdgdt01
 */
export const getVideoTypeName = videoType => {
  switch (videoType) {
    case 1:
      return 'regular'
    case 2:
      return 'quiz'
    case 3:
      return 'hbo'
    case 4:
      return 'regular-movies'
    default:
      return undefined
  }
}

export const getErrorCode = str => {
  let serverErrorCode = ['Network', '500', '501', '502', '503']
  let clientErrorCode = ['400', '401', '402', '403', '404']

  for (var i in serverErrorCode) {
    if (str.includes(serverErrorCode[i])) {
      return 502
    }
    if (str.includes(clientErrorCode[i])) {
      return 400
    }
  }
  return 1
}

/**
 *
 * @param {*} subs is a list of subscription from the user obtain from redux user via this.props.user.subscriptions
 * @param {*} playlistId subscriptions categories or subscriptions playlistId .e.g CoronaCare, EPL, EURO etc
 */
export const getActiveSubs = (subs = [], playlistId = 'CoronaCare') => {
  if (subs && subs.length > 0) {
    const activeSubs = subs
      .map(s => {
        let result = []

        const subsTypes = _get(s, 'attributes.playlists', [])
        const subsExp = _get(s, 'attributes.expireAt', '')

        if (subsTypes.length > 0) {
          result = subsTypes.map(t => ({
            name: _get(t, 'attributes.playlistId', 'invalid'),
            status: _get(t, 'attributes.status', 0),
            quality: _get(t, 'attributes.quality', 0),
            isAds: _get(t, 'attributes.ads', 1),
            isExpired: new Date() > new Date(subsExp),
          }))
        }
        return result
      })
      .flat()
      .filter(s => !s.isExpired && s.name === playlistId)

    return activeSubs
  }

  return []
}

export const getFormattedPrice = number => {
  if (!number || number == 0) {
    return 0
  }

  return number
    .toString()
    .split(/(?=(?:\d{3})+(?:\.|$))/g)
    .join(',')
}

export const copyCodeToClipboard = props => {
  var el = document.createElement('textarea')
  el.value = props.value ? props.value : props.content
  el.setAttribute('readonly', '')
  el.style = { position: 'absolute', left: '-9999px' }
  document.body.appendChild(el)
  el.select()
  document.execCommand('copy')
  document.body.removeChild(el)
}

export const readQueryParams = query => {
  const uriSearch = location.search
  if (!_isUndefined(uriSearch) && uriSearch !== '') {
    const urlParams = new URLSearchParams(uriSearch)
    return urlParams.get(query)
  }
  return
}

export const setCookie = (name, value, days) => {
  var expires = ''
  if (days) {
    var date = new Date()
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000)
    expires = '; expires=' + date.toUTCString()
  }

  document.cookie = name + '=' + (value || '') + expires + '; path=/'
}

export const getCookie = name => {
  var value = '; ' + document.cookie
  var parts = value.split('; ' + name + '=')
  if (parts.length == 2)
    return parts
      .pop()
      .split(';')
      .shift()
}

export const setBackToPageTitle = (pathname = '/', directTitle = '') => {
  const urlParams = queryString.parse(location.search)
  const idxQuery = pathname.indexOf('?')
  const filteredPath = idxQuery !== -1 ? pathname.substr(0, idxQuery) : pathname
  const pathnameArr = filteredPath.split('/')
  const title = directTitle ? directTitle : pathnameArr[pathnameArr.length - 1]
  const isMobile = /iPhone|iPod|Android/i.test(navigator.userAgent)
  let pathnameWithParams = queryString.stringifyUrl({ url: pathname, query: urlParams })

  if (title && isMobile) {
    pathnameWithParams = queryString.stringifyUrl({ url: pathnameWithParams, query: { btp: title } })
  }
  return pathnameWithParams
}

export const isValidHttpUrl = string => {
  let url

  try {
    url = new URL(string)
  } catch (_) {
    return false
  }

  return url.protocol === 'http:' || url.protocol === 'https:'
}

export const arrayToChunk = (array, perChunk) => {
  return array.reduce((resultArray, item, index) => {
    const chunkIndex = Math.floor(index / perChunk)
    if (!resultArray[chunkIndex]) {
      resultArray[chunkIndex] = [] // start a new chunk
    }
    resultArray[chunkIndex].push(item)
    return resultArray
  }, [])
}

export const arrayToObject = (array, key) => {
  const initialValue = {}
  return array.reduce((obj, item) => {
    const itemKey = key ? item[key].toString() : null
    return {
      ...obj,
      [itemKey || item]: item,
    }
  }, initialValue)
}

/**
 *
 * @param {Object} propsConfigParams from component props config params
 * @ex getPlatformId(this.props.configParams)
 */
export const getPlatformId = propsConfigParams => {
  const defaultPlatformId = _get(propsConfigParams, 'data.platform_id', 7)
  const qsPlatformId = readQueryParams('platformId')

  if (qsPlatformId) {
    return qsPlatformId
  }
  return defaultPlatformId
}

export const PlaylistStyle = {
  BLANK_LANDSCAPE: '1',
  BLANK_PORTRAIT: '2',
  TITLE_LANDSCAPE: '3',
  TITLE_PORTRAIT: '4',
  MOVIE_LANDSCAPE: '5',
  MOVIE_PORTRAIT: '6',
  MATCH_LANDSCAPE: '7',
  MATCH_PORTRAIT: '8',
  HIGHLIGHT_LANDSCAPE: '9',
  HIGHLIGHT_PORTRAIT: '10',
  CATEGORIES_LANDSCAPE: '11',
  CATEGORIES_PORTRAIT: '12',
  ORIGINALS_LANDSCAPE: '13',
  ORIGINALS_PORTRAIT: '14',
  BLANK_PORTRAIT_23: '15',
  TITLE_PORTRAIT_23: '16',
  MOVIE_PORTRAIT_23: '17',
  MATCH_PORTRAIT_23: '18',
  HIGHLIGHT_PORTRAIT_23: '19',
  CATEGORIES_PORTRAIT_23: '20',
  ORIGINALS_PORTRAIT_23: '21',
  MOVIE_LANDSCAPE_SECTION_FULL: '22',
  MOVIE_PORTRAIT_SECTION_FULL: '23',
  CATEGORIES_LANDSCAPE_FULL: '24',
  CATEGORIES_PORTRAIT_FULL: '25',
  CATEGORIES_LANDSCAPE_TITLE: '26',
  CATEGORIES_PORTRAIT_TITLE: '27',
  MOVIE_PORTRAIT_SECTION_FULL_23: '28',
  CATEGORIES_PORTRAIT_FULL_23: '29',
  CATEGORIES_PORTRAIT_TITLE_23: '30',
}

export const ContentStyle = {
  BLANK_LANDSCAPE: '1',
  BLANK_PORTRAIT: '2',
  TITLE_LANDSCAPE: '3',
  TITLE_PORTRAIT: '4',
  MOVIE_LANDSCAPE: '5',
  MOVIE_PORTRAIT: '6',
  MATCH_LANDSCAPE: '7',
  MATCH_PORTRAIT: '8',
  HIGHLIGHT_LANDSCAPE: '9',
  HIGHLIGHT_PORTRAIT: '10',
  BLANK_PORTRAIT_23: '11',
  TITLE_PORTRAIT_23: '12',
  MOVIE_PORTRAIT_23: '13',
  MATCH_PORTRAIT_23: '14',
  HIGHLIGHT_PORTRAIT_23: '15',
}

export const PageStyle = {
  NO_BANNER: '1',
  WITH_BANNER: '2',
}

export const ImageSize = {
  LANDSCAPE: 1,
  PORTRAIT: 2,
  PORTRAIT23: 3,
}

export const getSpecialRibbon = (obj, size) => {
  const ribbon = _get(obj, 'ribbon.attributes', {
    landscapeImageUrl: null,
    portraitImageUrl: null,
    portrait23ImageUrl: null,
    // landscapeImageUrl:
    //   'https://up.stag.mola.tv/imgres/8069fd1f-3683-47e8-a08b-a4182b678182/image/332f98c7-c539-4267-b502-690ecb93a536/image.png',
    // portraitImageUrl:
    //   'https://up.stag.mola.tv/imgres/8069fd1f-3683-47e8-a08b-a4182b678182/image/29091eb1-8328-4e09-943b-27e9bc872ef7/image.png',
    // portrait23ImageUrl:
    //   'https://up.stag.mola.tv/imgres/8069fd1f-3683-47e8-a08b-a4182b678182/image/b44e7b35-4b5a-4a68-9c02-6bbbe07be399/image.png',
  })
  switch (size) {
    case ImageSize.LANDSCAPE:
      return ribbon.landscapeImageUrl
    case ImageSize.PORTRAIT:
      return ribbon.portraitImageUrl
    case ImageSize.PORTRAIT23:
      return ribbon.portrait23ImageUrl
    default:
      return null
  }

  return null
}

/**
 * TODO: change naming to stringInterpolation because it can be used by regular string like translation
 * @param {string} str string with template interpolation someroute?key={{value}}&anotherKey={{anotherValue}}
 * @param {object} fields fields reflected key value for replacing template
 * @example ('/someroute?key={{value}}&anotherKey={{anotherValue}}', {
 *  value: 'some_id',
 *  anotherValue: 'kaboom'
 * })
 * @example ('randomstring {{value}} inside {{anotherValue}}', {
 *  value: 'some_id',
 *  anotherValue: 'kaboom'
 * })
 */
export const parseParamsInterpolation = (str, fields) => {
  const keys = str.match(/(\{\{[a-zA-Z]+\}\})/gi) || []
  return keys.reduce((prev, item) => {
    const key = /\{\{(\w+)\}\}/.exec(item)[1]
    if (!fields[key]) return prev
    const parsed = prev.replace(item, fields[key])
    return parsed
  }, str)
}

/**
 *
 * @param {array} arr array of object that have one key with same value. eg. [{ id: 3, title: 'Hello' }]
 * @param {array} arr2 array of object that have one key with same value. eg. [{ postId: 3, desc: 'So long..' }]
 * @param {array} keys array of key between both of them that have some values. eg. ['id', 'postId']
 * @example mergeArrayObjectSameKeyValue = ([{ id: 3, title: 'Hello' }, { id: 5, title: 'World' }], [{ postId: 3, desc: 'So long..' }] , ['id', 'postId'])
 * @returns {array} Array of merged objects with same key values. eg [{ id: 3, title: 'Hello', dpostId: 3, esc: 'So long..' }]
 */
export const mergeArrayObjectSameKeyValue = (arr, arr2, keys) => {
  let result = []

  arr.map(item =>
    arr2.map(item2 => {
      if (item[keys[0]] === item2[keys[1]]) {
        result.push({
          ...item,
          ...item2,
        })
      }
    }),
  )

  return result
}

/**
 * delete keys from object
 * @param {Object} obj 
 * @param {Array[String]} keys key you want to delete from object
 */
export const deleteKeys = (obj, keys) => {
  for (let i = 0; i < keys.length; i++) {
    delete obj[keys[i]]
  }
  return obj
}
